import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';

import {
	FORGE_MODULE_XEN_MACRO,
	FORGE_MODULE_GLOBAL_PAGE,
	FORGE_MODULE_CONTENT_ACTION,
	FORGE_MODULE_PAGE_BANNER,
	FORGE_MODULE_BYLINE,
	FORGE_MODULE_BACKGROUND_SCRIPT,
} from '../ForgeModuleType.ts';

import { preloadUseExtensionList } from './preloadUseExtensionList.ts';

const MODULE_TYPES = [
	FORGE_MODULE_XEN_MACRO,
	FORGE_MODULE_GLOBAL_PAGE,
	FORGE_MODULE_CONTENT_ACTION,
	FORGE_MODULE_PAGE_BANNER,
	FORGE_MODULE_BYLINE,
	FORGE_MODULE_BACKGROUND_SCRIPT,
];

export const preloadAllViewPageExtensions = async ({
	contentId,
	spaceKey,
}: {
	contentId?: string;
	spaceKey: string;
}) => {
	return waitForAllReturnWhenError(
		MODULE_TYPES.flatMap((moduleType) =>
			moduleType === FORGE_MODULE_XEN_MACRO
				? [
						preloadUseExtensionList({ contentId, spaceKey, moduleType }),
						preloadUseExtensionList({ contentId, spaceKey, moduleType, includeHidden: true }),
					]
				: preloadUseExtensionList({ contentId, spaceKey, moduleType }),
		),
	);
};
